<template>
  <main class="mdl-layout__content" >

    <div v-if="section" class="page-content">
	    
      <h1 class="mdl-typography--headline" v-text="translate(section.captionNumbered)"></h1>

      <template v-for="category in section.categories">
        <h2 class="mdl-typography--title">
          <span v-text="translate(category.caption)"></span>
          <button v-if="isEditable()" @click="updateAnswers($event, category)" class="btnUpdAnswers mdl-button mdl-js-button mdl-button--icon green">
            <i class="material-icons">done_all</i>
          </button>
        </h2>
        <table class="mdl-data-table mdl-shadow--2dp" style="width:100%;">
          <tbody>
          <template v-for="item in category.items">
            <tr v-bind:class="[getStateColor(item.state)]">
	          <td class="mdl-data-table__cell--non-numeric	captionNumbered" v-text="item.caption_numbered"></td>
              <td class="mdl-data-table__cell--non-numeric" v-text="item.caption.replace('Dekk og felg', translate('Dekk og felg'))"></td>
              <td v-if="isEditable()">
                <button @click="copyEmptyItem(item)" class="mdl-button mdl-js-button mdl-button--icon blue">
                  <i class="material-icons">add</i>
                </button>
                <button @click="changeAnswerState(item,1)" class="mdl-button mdl-js-button mdl-button--icon green">
                  <i class="material-icons">done</i>
                </button>
                <button v-if="!isEuropcarReport()" @click="changeAnswerState(item,0)" class="mdl-button mdl-js-button mdl-button--icon yellow">
                  <i class="material-icons">error_outline</i>
                </button>
                <button @click="changeAnswerState(item,-1)" class="mdl-button mdl-js-button mdl-button--icon red">
                  <i class="material-icons">close</i>
                </button>
              </td>
            </tr>
            <tr @change="saveAnswers([item])" v-if="parseInt(item.state) < 1 || (parseInt(item.state) < 2 && item.is_condition_needed)" class="item-assessment-report" :class="[getStateColor(item.state)]">
              <td colspan="3">
                <form>
                  <!--<div v-if="item.image" v-bind:style="item.image ? { backgroundImage: 'url(' + (item.image ? item.image : '') + ')' } : ''" class="item-assessment-report_image-placeholder">
                    <label v-if="isEditable()" v-bind:for="'item-image' + item.id" class="mdl-button mdl-js-button mdl-button--icon">
                      <input class="photo-camera-input" v-bind:id="'item-image' + item.id" type="text" @click="openPopupRemoveImage($event,item)" >
                      <i class="material-icons">cancel</i>
                    </label>
                  </div>-->
                  <div class="item-assessment-report_image-placeholder">
                    <div v-if="item.images" class="images">
                      <div @click="$root.showLightbox(item.images, imageIndex)" v-for="(image,imageIndex) in item.images" v-bind:style="image ? { backgroundImage: 'url(' + (image ? image : '') + ')' } : ''">
                        <label @click.prevent.stop="removeAnswerImage(item, imageIndex)" class="mdl-button mdl-js-button mdl-button--icon image-delete">
                          <i class="material-icons" style="color:white !important;">delete</i>
                        </label>
                        <label @click="$root.showLightbox(item.images, imageIndex)" class="mdl-button mdl-js-button mdl-button--icon image-open">
                          <i class="material-icons" style="color:white !important;">open_with</i>
                        </label>
                      </div>
                    </div>
                    <label v-if="isEditable()" v-bind:for="'item-image' + item.id" class="mdl-button mdl-js-button mdl-button--icon">
                      <input class="photo-camera-input" v-bind:id="'item-image' + item.id" type="file" @change.prevent.stop="uploadImage($event,item)" accept="image/*">
                      <i class="material-icons">photo_camera</i>
                    </label>
                  </div>

                  <div class="item-assessment-report_description">
                    <div class="mdl-textfield mdl-js-textfield textSelector" style="width:100%; display: block;">
                      <v-select v-if="isEditable()" :onChange="function(val){

                        val.content = translate(val.content);
                        onAutoReplySelect(item,val)
                      }" placeholder="Merknad" v-model.lazy="item.description" label="content" :options="grouped_items_replies">
                        <template slot="option" slot-scope="{ content,title }">
                            <div v-if="content">{{ translate(content) }}</div>
                            <div v-else disabled="disabled" @click.stop="function(e){return false}"><b v-text="translate(title)"></b></div>
                        </template>
                      </v-select>
                      <textarea :disabled="!isEditable()" v-model.lazy="item.description" class="mdl-textfield__input" type="text" rows= "1" v-bind:id="'description' + item.id" ></textarea>
                      <label class="mdl-textfield__label" v-bind:for="'description' + item.id" v-text="translate('Standard skadebeskrivelse')"></label>
                    </div>
                    <div class="mdl-textfield mdl-js-textfield" style="width:100%; display: block;">
                      <textarea :disabled="!isEditable()" v-model.lazy="item.condition_value" class="mdl-textfield__input" type="text" rows= "1" v-bind:id="'condition_value' + item.id" ></textarea>
                      <label class="mdl-textfield__label" v-bind:for="'condition_value' + item.id">
                        <template v-if="item.condition_caption">
                          <span v-text="translate(item.condition_caption)"></span>
                        </template>
                        <template v-else>
                          <span>{{ translate('Skadebeskrivelse/Måleverdi') }}</span>
                        </template>
                      </label>
                    </div>
                    <div v-if="item.extra_caption" class="mdl-textfield mdl-js-textfield" style="width:100%; display: block;">
                      <textarea :disabled="!isEditable()" v-model.lazy="item.extra_value" class="mdl-textfield__input" type="text" rows= "1" :id="'extra_value' + item.id" ></textarea>
                      <label class="mdl-textfield__label" :for="'extra_value' + item.id">
                        <span v-text="translate(item.extra_caption)"></span>
                      </label>
                    </div>
                    
                    <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label" style="width:100%;  display: none;">
                      <input :disabled="!isEditable()" v-model.lazy="item.estimate" pattern="[0-9]*(\.[0-9]{1,2})?" class="mdl-textfield__input" type="text" v-bind:id="'estimate' + item.id">
                      <label class="mdl-textfield__label" v-bind:for="'estimate' + item.id" v-text="translate('Pris/Verdireduksjon')"></label>
                      <span class="mdl-textfield__error" v-text="translate('Input må være et tall')"></span>
                    </div>
                    <div v-if="$root.isSurveyorCapability()" v-for="lineitem in item.lineitems">
                      <div v-if="'en' === report.report_language" class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label lineItemDesc textSelector" :style="isWithoutPrice() ? {width:'100%'} : {}">
                        <v-select v-if="isEditable()" :onChange="function(val){onLineItemSelect(item, lineitem, val)}" placeholder="Merknad" v-model.lazy="lineitem.description_en" label="description_en" :options="line_item_descriptions"></v-select>
                        <textarea @change="onLineItemChange(lineitem)" :disabled="!isEditable()" v-model.lazy="lineitem.description_en" class="mdl-textfield__input" type="text" rows= "1" v-bind:id="'linedescription' + lineitem.id" ></textarea>
                        <label class="mdl-textfield__label" v-bind:for="'linedescription' + lineitem.id" v-text="translate('Beskrivelse av verdireduksjon')"></label>
                      </div>

                      <div v-else-if="'da' === report.report_language" class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label lineItemDesc textSelector" :style="isWithoutPrice() ? {width:'100%'} : {}">
                        <v-select v-if="isEditable()" :onChange="function(val){onLineItemSelect(item, lineitem, val)}" placeholder="Merknad" v-model.lazy="lineitem.description_da" label="description_da" :options="line_item_descriptions"></v-select>
                        <textarea @change="onLineItemChange(lineitem)" :disabled="!isEditable()" v-model.lazy="lineitem.description_da" class="mdl-textfield__input" type="text" rows= "1" v-bind:id="'linedescription' + lineitem.id" ></textarea>
                        <label class="mdl-textfield__label" v-bind:for="'linedescription' + lineitem.id" v-text="translate('Beskrivelse av verdireduksjon')"></label>
                      </div>

                      <div v-else-if="'sv' === report.report_language" class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label lineItemDesc textSelector" :style="isWithoutPrice() ? {width:'100%'} : {}">
                        <v-select v-if="isEditable()" :onChange="function(val){onLineItemSelect(item, lineitem, val)}" placeholder="Merknad" v-model.lazy="lineitem.description_sv" label="description_sv" :options="line_item_descriptions"></v-select>
                        <textarea @change="onLineItemChange(lineitem)" :disabled="!isEditable()" v-model.lazy="lineitem.description_sv" class="mdl-textfield__input" type="text" rows= "1" v-bind:id="'linedescription' + lineitem.id" ></textarea>
                        <label class="mdl-textfield__label" v-bind:for="'linedescription' + lineitem.id" v-text="translate('Beskrivelse av verdireduksjon')"></label>
                      </div>

                      <div v-else class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label lineItemDesc textSelector" :style="isWithoutPrice() ? {width:'100%'} : {}">
                        <v-select v-if="isEditable()" :onChange="function(val){onLineItemSelect(item, lineitem, val)}" placeholder="Merknad" v-model.lazy="lineitem.description" label="description" :options="line_item_descriptions"></v-select>
                        <textarea @change="onLineItemChange(lineitem)" :disabled="!isEditable()" v-model.lazy="lineitem.description" class="mdl-textfield__input" type="text" rows= "1" v-bind:id="'linedescription' + lineitem.id" ></textarea>
                        <label class="mdl-textfield__label" v-bind:for="'linedescription' + lineitem.id" v-text="translate('Beskrivelse av verdireduksjon')"></label>
                      </div>

                      <div v-if="!isWithoutPrice()" class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label lineItemCost">
                        <input :disabled="!isEditable()" v-model.lazy="lineitem.cost" pattern="[0-9]*(\.[0-9]{1,2})?" class="mdl-textfield__input sectionItemCostColumn" type="text" v-bind:id="'lineitem_cost' + lineitem.id">
                        <label class="mdl-textfield__label" v-bind:for="'lineitem_cost' + lineitem.id" v-text="translate('Pris')"></label>
                        <span class="mdl-textfield__error" v-text="translate('Input må være et tall')"></span>
                      </div>
                    </div>
                    <div v-if="$root.isSurveyorCapability()">
	                  <div @click="addLineItem(item)" class="mdl-button mdl-js-button mdl-button--icon green newlineitem-button">
			            <i class="material-icons">playlist_add</i>
			          </div>
                    </div>
                    
                  </div>
                </form>
              </td>
            </tr>
            
          </template>
          </tbody>
        </table>
        <button v-if=" isEditable() && !section.inspection_off " @click="addCustomItem(category)" style="float:right;margin:10px;" class="mdl-button mdl-button--raised" v-text="translate('Legg til ekstra felt')"></button>
      </template>
    </div>
<!--
    <div class="at-modal" v-if="popup.visible"  @click.self="popup.visible=false">
        <div class="at-modal-content mdl-shadow--2dp mdl-grid">
            <p>Ønsker du å slette bildet?</p>
            
            <div class="actions">
                <button @click="popup.visible=false" class="mdl-button mdl-js-button mdl-button--raised">
                    Avbryt
                </button>
                <button :disabled="$root.ui.isLoading('dataSaving')" @click="removeImage(popup.item)" class="mdl-button mdl-js-button mdl-button--raised">
                    Ja
                </button>
            </div>
        </div>
	</div> 
-->
    <div class="tab-bar">
      <!-- Colored raised button -->
      <button @click="previous" class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored-grey">Lukk</button>
      <!-- Accent-colored raised button -->
      <button :disabled="$root.ui.isLoading('sendAnswers')" @click="next" class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored-green">Neste</button>
    </div>
  </main>

</template>

<script>

  import report from '../mixins/report.js'
  import reportValues from '../mixins/reportValues.js'

  import mdlFix from '../mixins/mdlFix.js'
  import utils from '../mixins/utils.js'

  export default {
    data () {
      return {
        popup: {
            visible: false, 
            item: false,                   
        }
      }
    },
    mixins: [report,reportValues,mdlFix,utils],
    methods: {
        openPopupRemoveImage(event,item){
            this.popup.item = item;
            this.popup.visible = true;
        },
    }
  }
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// ReportSection.vue?0cff5f1f